export const organizationsFormatter = (organizations: string) => {
  try {
    return JSON.parse(
      `{"${organizations.replace(/:/g, '":"').replace(/,/g, '","')}"}`
    );
  } catch (error) {
    return {};
  }
};

export const backendURLFormatter = (str: string) => {
  try {
    return JSON.parse(`{"${str.replace(/=/g, '":"').replace(/,/g, '","')}"}`);
  } catch (error) {
    return {};
  }
};
